import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { setPageTitle } from '../Storage/Redux/slice/themeConfigSlice';

function AccessDenied() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPageTitle('Access Denied'));
  }, []);

  return (
    <div className="min-h-screen bg-red-300 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          <h2 className="mt-6 text-3xl font-extrabold text-red-900">
            Access Denied
          </h2>
          <p className="mt-2 text-sm text-red-600">
            Sorry, you don't have permission to access this page.
          </p>
        </div>
        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-red-400 py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <div className="text-sm text-red-700">
              <p className="mb-2">
                If you believe this is a mistake, please contact the
                administrator.
              </p>
              <p>
                You can go back to the{' '}
                <Link to="/" className="text-indigo-600 hover:text-indigo-500">
                  Homepage
                </Link>
                .
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccessDenied;
